import Vue from "vue";
import VueRouter from "vue-router";
import registerInterceptor from "./register-interceptor";

Vue.use(VueRouter);

const baseRoutes = [
  {
    name: "404",
    path: "/404",
    component: () => import(/* webpackChunkName: "404" */ "@/views/404.vue"),
    meta: {
      title: "404"
    }
  },
  {
    name: "Login",
    path: "/login",
    component: () => import(/* webpackChunkName: "login" */ "@/views/login/index.vue"),
    meta: {
      title: "登录"
    }
  },
  {
    path: "/",
    component: () => import("@/Layout/index.vue"),
    children: []
  },
  {
    path: "*",
    redirect: "/404"
  }
];
// const dynamicsRoutes = [];
const dynamicsRoutes = [
  {
    path: "/",
    component: () => import("@/Layout/index.vue"),
    children: [
      // 驾驶舱
      {
        name: "HomePage",
        path: "/HomePage",
        component: () => import(/* webpackChunkName: "HomePage" */ "@/views/HomePage/index.vue"),
        meta: {
          title: "驾驶舱" // 管理员首页
        }
      },
      // 订单管理
      {
        name: "OrderManagement",
        path: "/OrderManagement/index",
        component: () => import(/* webpackChunkName: "OrderManagement" */ "@/views/OrderManagement/index.vue"),
        meta: {
          title: "订单管理"
        }
      },
      // 货主管理
      {
        name: "ShipperManagement",
        path: "/ShipperManagement/index",
        component: () => import(/* webpackChunkName: "ShipperManagement" */ "@/views/ShipperManagement/index.vue"),
        meta: {
          title: "货主管理"
        }
      },

      /*********************************************************/
      // 审批中心
      /*********************************************************/
      // 审批中心-司机信息审批
      {
        name: "DriverInformationApproval",
        path: "/ApprovalCenter/DriverInformationApproval/index",
        component: () =>
          import(
            /* webpackChunkName: "DriverInformationApproval" */ "@/views/ApprovalCenter/DriverInformationApproval/index.vue"
          ),
        meta: {
          title: "司机信息审批"
        }
      },
      // 审批中心-司机上线费用审批
      {
        name: "DriverOnlineFeeApproval",
        path: "/ApprovalCenter/DriverOnlineFeeApproval/index",
        component: () =>
          import(
            /* webpackChunkName: "DriverInformationApproval" */ "@/views/ApprovalCenter/DriverOnlineFeeApproval/index.vue"
          ),
        meta: {
          title: "司机上线费用审批"
        }
      },
      // 审批中心-订单取消审批
      {
        name: "OrderCancelApproval",
        path: "/ApprovalCenter/OrderCancelApproval/index",
        component: () =>
          import(
            /* webpackChunkName: "DriverInformationApproval" */ "@/views/ApprovalCenter/OrderCancelApproval/index.vue"
          ),
        meta: {
          title: "订单取消审批"
        }
      },
      // 审批中心-订单改派审批
      {
        name: "OrderReassignmentApproval",
        path: "/ApprovalCenter/OrderReassignmentApproval/index",
        component: () =>
          import(
            /* webpackChunkName: "DriverInformationApproval" */ "@/views/ApprovalCenter/OrderReassignmentApproval/index.vue"
          ),
        meta: {
          title: "订单改派审批"
        }
      },
      // 审批中心-司机推广审批
      {
        name: "DriverPromotionApproval",
        path: "/ApprovalCenter/DriverPromotionApproval/index",
        component: () =>
          import(
            /* webpackChunkName: "DriverInformationApproval" */ "@/views/ApprovalCenter/DriverPromotionApproval/index.vue"
          ),
        meta: {
          title: "司机推广审批"
        }
      },
      /*********************************************************/
      // 调度工作台
      /*********************************************************/
      // 调度工作台-订单调度
      {
        name: "OrderScheduling",
        path: "/SchedulingWorkbench/OrderScheduling/index",
        component: () =>
          import(/* webpackChunkName: "OrderScheduling" */ "@/views/SchedulingWorkbench/OrderScheduling/index.vue"),
        meta: {
          title: "订单调度"
        }
      },
      // 调度工作台-订单改派
      {
        name: "OrderReassignment",
        path: "/SchedulingWorkbench/OrderReassignment/index",
        component: () =>
          import(/* webpackChunkName: "OrderScheduling" */ "@/views/SchedulingWorkbench/OrderReassignment/index.vue"),
        meta: {
          title: "订单改派"
        }
      },
      // 调度工作台-调度资源管理
      {
        name: "SchedulingResourceManagement",
        path: "/SchedulingWorkbench/SchedulingResourceManagement/index",
        component: () =>
          import(
            /* webpackChunkName: "OrderScheduling" */ "@/views/SchedulingWorkbench/SchedulingResourceManagement/index.vue"
          ),
        meta: {
          title: "调度资源管理"
        }
      },
      /*********************************************************/

      /*********************************************************/
      // 订单管理
      {
        name: "OrderManagement",
        path: "/OrderManagement/index",
        component: () => import(/* webpackChunkName: "OrderManagement" */ "@/views/OrderManagement/index.vue"),
        meta: {
          title: "订单管理"
        }
      },
      // 订单审单
      {
        name: "OrderReview",
        path: "/OrderReview/index",
        component: () => import(/* webpackChunkName: "OrderManagement" */ "@/views/OrderReview/index.vue"),
        meta: {
          title: "订单审单"
        }
      },
      /*********************************************************/
      // 车队长工作台
      /*********************************************************/
      // 车队长工作台-实时监控
      {
        name: "RealtimeMonitoring",
        path: "/FleetLeaderWorkbench/RealtimeMonitoring/index",
        component: () =>
          import(
            /* webpackChunkName: "RealtimeMonitoring" */ "@/views/FleetLeaderWorkbench/RealtimeMonitoring/index.vue"
          ),
        meta: {
          title: "实时监控"
        }
      },
      // 车队长工作台-车辆GPS监控
      {
        name: "DriverTransitMonitoring",
        path: "/FleetLeaderWorkbench/DriverTransitMonitoring/index",
        component: () =>
          import(
            /* webpackChunkName: "RealtimeMonitoring" */ "@/views/FleetLeaderWorkbench/DriverTransitMonitoring/index.vue"
          ),
        meta: {
          title: "车辆GPS监控"
        }
      },
      // 业务数据中心-平台司机管理
      {
        name: "PlatformDriverManagement",
        path: "/FleetLeaderWorkbench/PlatformDriverManagement/index",
        component: () =>
          import(
            /* webpackChunkName: "RealtimeMonitoring" */ "@/views/FleetLeaderWorkbench/PlatformDriverManagement/index.vue"
          ),
        meta: {
          title: "平台司机管理"
        }
      },
      // 业务数据中心-临调司机管理
      {
        name: "TemporaryAdjustmentDriverManagement",
        path: "/FleetLeaderWorkbench/TemporaryAdjustmentDriverManagement/index",
        component: () =>
          import(
            /* webpackChunkName: "RealtimeMonitoring" */ "@/views/FleetLeaderWorkbench/TemporaryAdjustmentDriverManagement/index.vue"
          ),
        meta: {
          title: "临调司机管理"
        }
      },
      // 车队长工作台-司机排班管理
      {
        name: "DriverWorkforceManagement",
        path: "/FleetLeaderWorkbench/DriverWorkforceManagement/index",
        component: () =>
          import(
            /* webpackChunkName: "RealtimeMonitoring" */ "@/views/FleetLeaderWorkbench/DriverWorkforceManagement/index.vue"
          ),
        meta: {
          title: "司机排班管理"
        }
      },
      // 车队长工作台-司机流失预警
      {
        name: "DriverChurnWarning",
        path: "/FleetLeaderWorkbench/DriverChurnWarning/index",
        component: () =>
          import(
            /* webpackChunkName: "RealtimeMonitoring" */ "@/views/FleetLeaderWorkbench/DriverChurnWarning/index.vue"
          ),
        meta: {
          title: "司机流失预警"
        }
      },
      /*********************************************************/
      // 客服工作台
      /*********************************************************/
      // 客服工作台-订单查询
      {
        name: "CustomerServiceWorkbench",
        path: "/CustomerServiceWorkbench/OrderQuery/index",
        component: () =>
          import(
            /* webpackChunkName: "CustomerServiceWorkbench" */ "@/views/CustomerServiceWorkbench/OrderQuery/index.vue"
          ),
        meta: {
          title: "订单查询"
        }
      },
      // 客服工作台-新司机订单跟单
      {
        name: "CustomerServiceWorkbench",
        path: "/CustomerServiceWorkbench/NewDriverOrderFollowUp/index",
        component: () =>
          import(
            /* webpackChunkName: "CustomerServiceWorkbench" */ "@/views/CustomerServiceWorkbench/NewDriverOrderFollowUp/index.vue"
          ),
        meta: {
          title: "平台订单查询"
        }
      },

      // 客服工作台-待核价订单
      {
        name: "PendingPriceOrder",
        path: "/CustomerServiceWorkbench/PendingPriceOrder/index",
        component: () =>
          import(
            /* webpackChunkName: "CustomerServiceWorkbench" */ "@/views/CustomerServiceWorkbench/PendingPriceOrder/index.vue"
          ),
        meta: {
          title: "待核价订单"
        }
      },

      // 客服工作台-回单订单
      {
        name: "ReturnOrder",
        path: "/CustomerServiceWorkbench/ReturnOrder/index",
        component: () =>
          import(
            /* webpackChunkName: "CustomerServiceWorkbench" */ "@/views/CustomerServiceWorkbench/ReturnOrder/index.vue"
          ),
        meta: {
          title: "回单订单"
        }
      },

      // 客服工作台-电话下单记录
      {
        name: "TelephoneOrderRecord",
        path: "/CustomerServiceWorkbench/TelephoneOrderRecord/index",
        component: () =>
          import(
            /* webpackChunkName: "CustomerServiceWorkbench" */ "@/views/CustomerServiceWorkbench/TelephoneOrderRecord/index.vue"
          ),
        meta: {
          title: "电话下单记录"
        }
      },

      // 客服工作台-投诉建议管理
      {
        name: "ComplaintSuggestionManagement",
        path: "/CustomerServiceWorkbench/ComplaintSuggestionManagement/index",
        component: () =>
          import(
            /* webpackChunkName: "CustomerServiceWorkbench" */ "@/views/CustomerServiceWorkbench/ComplaintSuggestionManagement/index.vue"
          ),
        meta: {
          title: "投诉建议管理"
        }
      },

      /*********************************************************/
      // 报表中心
      /*********************************************************/
      // 报表中心-司机基础信息报表
      {
        name: "DriverBasicInformationReport",
        path: "/StatementCenter/DriverBasicInformationReport/index",
        component: () =>
          import(
            /* webpackChunkName: "DriverBasicInformationReport" */ "@/views/StatementCenter/DriverBasicInformationReport/index.vue"
          ),
        meta: {
          title: "实时监控"
        }
      },
      // 报表中心-订单明细报表
      {
        name: "OrderDetailsReport",
        path: "/StatementCenter/OrderDetailsReport/index",
        component: () =>
          import(
            /* webpackChunkName: "DriverBasicInformationReport" */ "@/views/StatementCenter/OrderDetailsReport/index.vue"
          ),
        meta: {
          title: "订单明细报表"
        }
      },
      // 报表中心-司机派单明细表
      {
        name: "DriverDetailsReport",
        path: "/StatementCenter/DriverDetailsReport/index",
        component: () =>
          import(
            /* webpackChunkName: "DriverDetailsReport" */ "@/views/StatementCenter/DriverDetailsReport/index.vue"
          ),
        meta: {
          title: "司机派单明细表"
        }
      },
      // 报表中心-司机业绩汇总表
      {
        name: "DriverPerformanceReport",
        path: "/StatementCenter/DriverPerformanceReport/index",
        component: () =>
          import(
            /* webpackChunkName: "DriverPerformanceReport" */ "@/views/StatementCenter/DriverPerformanceReport/index.vue"
          ),
        meta: {
          title: "司机业绩汇总表"
        }
      },
      // 报表中心-司机出勤率报表
      {
        name: "DriverAttendanceRate",
        path: "/StatementCenter/DriverAttendanceRate/index",
        component: () =>
          import(
            /* webpackChunkName: "DriverAttendanceRate" */ "@/views/StatementCenter/DriverAttendanceRate/index.vue"
          ),
        meta: {
          title: "司机出勤率"
        }
      },
      // 报表中心-周度司机出勤率报表
      {
        name: "WeekDriverAttendanceRate",
        path: "/StatementCenter/WeekDriverAttendanceRate/index",
        component: () =>
          import(
            /* webpackChunkName: "WeekDriverAttendanceRate" */ "@/views/StatementCenter/WeekDriverAttendanceRate/index.vue"
          ),
        meta: {
          title: "周度司机出勤率报表"
        }
      },
      // 报表中心-营收报表
      {
        name: "RevenueReport",
        path: "/StatementCenter/RevenueReport/index",
        component: () =>
          import(/* webpackChunkName: "DriverBasicInformationReport" */ "@/views/StatementCenter/RevenueReport/index.vue"),
        meta: {
          title: "营收报表"
        }
      },
      /*********************************************************/
      // 财务管理
      /*********************************************************/
      // 财务管理-钱包管理
      {
        name: "WalletManagement",
        path: "/FinancialManagement/WalletManagement/index",
        component: () =>
          import(/* webpackChunkName: "WalletManagement" */ "@/views/FinancialManagement/WalletManagement/index.vue"),
        meta: {
          title: "钱包管理"
        }
      },
      // 财务管理-对账单管理
      {
        name: "ReconciliationBill",
        path: "/FinancialManagement/ReconciliationBill/index",
        component: () =>
          import(/* webpackChunkName: "ReconciliationBill" */ "@/views/FinancialManagement/ReconciliationBill/index.vue"),
        meta: {
          title: "对账单管理"
        }
      },
      // 财务管理-资金流水
      {
        name: "FundTransaction",
        path: "/FinancialManagement/FundTransaction/index",
        component: () =>
          import(/* webpackChunkName: "FundTransaction" */ "@/views/FinancialManagement/FundTransaction/index.vue"),
        meta: {
          title: "资金流水"
        }
      },
      // 财务管理-代理商结算单
      {
        name: "SupplierSettlementBill",
        path: "/FinancialManagement/SupplierSettlementBill/index",
        component: () =>
          import(/* webpackChunkName: "SupplierSettlementBill" */ "@/views/FinancialManagement/SupplierSettlementBill/index.vue"),
        meta: {
          title: "代理商结算单"
        }
      },
      // 财务管理-服务商结算单
      {
        name: "AgentSettlementBill",
        path: "/FinancialManagement/AgentSettlementBill/index",
        component: () =>
          import(/* webpackChunkName: "AgentSettlementBill" */ "@/views/FinancialManagement/AgentSettlementBill/index.vue"),
        meta: {
          title: "服务商结算单"
        }
      },
      // 财务管理-充值记录
      {
        name: "RechargeRecord",
        path: "/FinancialManagement/RechargeRecord/index",
        component: () =>
          import(/* webpackChunkName: "RechargeRecord" */ "@/views/FinancialManagement/RechargeRecord/index.vue"),
        meta: {
          title: "充值记录"
        }
      },
      // 财务管理-提现管理
      {
        name: "WithdrawalManagement",
        path: "/FinancialManagement/WithdrawalManagement/index",
        component: () =>
          import(
            /* webpackChunkName: "WalletManagement" */ "@/views/FinancialManagement/WithdrawalManagement/index.vue"
          ),
        meta: {
          title: "提现管理"
        }
      },
      // 财务管理-司机欠款单
      {
        name: "DriverDebtReceipt",
        path: "/FinancialManagement/DriverDebtReceipt/index",
        component: () =>
          import(/* webpackChunkName: "WalletManagement" */ "@/views/FinancialManagement/DriverDebtReceipt/index.vue"),
        meta: {
          title: "司机欠款单"
        }
      },
      // 财务管理-发票申请
      {
        name: "InvoicesApply",
        path: "/FinancialManagement/InvoicesApply/index",
        component: () =>
          import(/* webpackChunkName: "WalletManagement" */ "@/views/FinancialManagement/InvoicesApply/index.vue"),
        meta: {
          title: "发票申请"
        }
      },

      /*********************************************************/
      // 业务配置
      /*********************************************************/
      // 业务配置-承运线路配置
      {
        name: "CarrierRouteConfig",
        path: "/ServiceConfig/CarrierRouteConfig/index",
        component: () =>
          import(/* webpackChunkName: "CarrierRouteConfig" */ "@/views/ServiceConfig/CarrierRouteConfig/index.vue"),
        meta: {
          title: "承运线路配置"
        }
      },

      // 业务配置-订单计费规则配置
      {
        name: "OrderBillingRuleConfig",
        path: "/ServiceConfig/OrderBillingRuleConfig/index",
        component: () =>
          import(/* webpackChunkName: "CarrierRouteConfig" */ "@/views/ServiceConfig/OrderBillingRuleConfig/index.vue"),
        meta: {
          title: "订单计费规则配置"
        }
      },

      // 业务配置-分佣规则配置
      {
        name: "CommissionSharingRuleConfig",
        path: "/ServiceConfig/CommissionSharingRuleConfig/index",
        component: () =>
          import(
            /* webpackChunkName: "CarrierRouteConfig" */ "@/views/ServiceConfig/CommissionSharingRuleConfig/index.vue"
          ),
        meta: {
          title: "分佣规则配置"
        }
      },
      // 业务配置-基础业务规则配置
      {
        name: "BasicBusinessRuleConfig",
        path: "/ServiceConfig/BasicBusinessRuleConfig/index",
        component: () =>
          import(
            /* webpackChunkName: "CarrierRouteConfig" */ "@/views/ServiceConfig/BasicBusinessRuleConfig/index.vue"
          ),
        meta: {
          title: "基础业务规则配置"
        }
      },
      /*********************************************************/
      // 系统管理
      /*********************************************************/
      // 系统管理-代理商管理
      {
        name: "AgentManagement",
        path: "/SystemManagement/AgentManagement/index",
        component: () =>
          import(/* webpackChunkName: "AgentManagement" */ "@/views/SystemManagement/AgentManagement/index.vue"),
        meta: {
          title: "代理商管理"
        }
      },
      // 系统管理-服务商管理
      {
        name: "ServiceManagement",
        path: "/SystemManagement/ServiceManagement/index",
        component: () =>
          import(/* webpackChunkName: "AgentManagement" */ "@/views/SystemManagement/ServiceManagement/index.vue"),
        meta: {
          title: "服务商管理"
        }
      },
      // 系统管理-分公司管理
      {
        name: "BranchManagement",
        path: "/SystemManagement/BranchManagement/index",
        component: () =>
          import(/* webpackChunkName: "BranchManagement" */ "@/views/SystemManagement/BranchManagement/index.vue"),
        meta: {
          title: "分公司管理"
        }
      },
      // 系统管理-第三方应用管理
      {
        name: "ExternalAppManagement",
        path: "/SystemManagement/ExternalAppManagement/index",
        component: () =>
          import(/* webpackChunkName: "ExternalAppManagement" */ "@/views/SystemManagement/ExternalAppManagement/index.vue"),
        meta: {
          title: "第三方应用管理"
        }
      },
      // 系统管理-员工管理
      {
        name: "StaffManagement",
        path: "/SystemManagement/StaffManagement/index",
        component: () =>
          import(/* webpackChunkName: "AgentManagement" */ "@/views/SystemManagement/StaffManagement/index.vue"),
        meta: {
          title: "员工管理"
        }
      },
      // 系统管理-角色权限管理
      {
        name: "RolePermissionManagement",
        path: "/SystemManagement/RolePermissionManagement/index",
        component: () =>
          import(
            /* webpackChunkName: "AgentManagement" */ "@/views/SystemManagement/RolePermissionManagement/index.vue"
          ),
        meta: {
          title: "角色权限管理"
        }
      },

      // 个人中心
      {
        name: "PersonalCenter",
        path: "/PersonalCenter",
        component: () => import(/* webpackChunkName: "AgentManagement" */ "@/views/PersonalCenter/index.vue"),
        meta: {
          title: "个人信息" // 个人信息
        }
      },
      // 字典类型管理
      {
        name: "DictManagement",
        path: "/SystemManagement/DictManagement/index",
        component: () =>
          import(/* webpackChunkName: "AgentManagement" */ "@/views/SystemManagement/DictManagement/index.vue"),
        meta: {
          title: "字典管理"
        }
      },
      // apk管理
      {
        name: "ApkManagement",
        path: "/SystemManagement/ApkManagement/index",
        component: () =>
          import(/* webpackChunkName: "ApkManagement" */ "@/views/SystemManagement/ApkManagement/index.vue"),
        meta: {
          title: "APK管理"
        }
      }
    ]
  }
];
const router = new VueRouter({
  mode: "hash",
  base: process.env.VUE_APP_ROUTER_BASE,
  routes: baseRoutes.concat(dynamicsRoutes)
});
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => {
    if (err.name !== "NavigationDuplicated") throw err;
  });
};
// /* 注册路由拦截器 */
registerInterceptor(router);

export default router;
